import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'nc-dock',
  templateUrl: './dock.component.html',
  styleUrls: ['./dock.component.less'],
})
export class DockComponent implements OnInit, OnDestroy {
  // 图标尺寸
  @Input() ncSize: number = 40;
  // 鼠标到最远放大图标的距离
  @Input() ncDistance: number = 140;
  // 展示模式
  @Input() ncMode: 'distance' | 'magnification' = 'distance'
  // 相对于ncSize放大或间隙的倍数
  @Input() ncMultiple: number = 1.5;
  // 主题
  @Input() ncTheme: 'light' | 'dark' = 'light';
  // 方向
  @Input() ncDirection: 'horizontal' | 'vertical' = 'horizontal';
  // 分割线
  @Input() ncDividerIndex: number[] = [];
  // 提示文本
  @Input() ncTooltip: string[] = [];
  // 提示文本位置
  @Input() ncTooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
  // hover效果
  private _hover: boolean = false;
  @Input()
  set ncHover(val: boolean | string) {
    this._hover = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncHover(): boolean {
    return this._hover;
  }
  // 图标列表
  private _items: string[] = [];
  @Input()
  set ncItems(value: string[]) {
    this._items = value;
    setTimeout(() => {
      this.resetIconScales();
    });
  }
  get ncItems(): string[] {
    return this._items;
  }
  // 图标点击事件
  @Output() ncClick = new EventEmitter<number>();

  @ViewChild('dockContainer') dockContainer!: ElementRef;

  private mouseXY = Infinity;
  iconScales: number[] = [];
  private isAnimating = false;
  private animationFrameId: number | null = null;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
    }
  }

  private resetIconScales(): void {
    this.iconScales = this.ncItems.map(() => this.ncSize);
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (this.ncDirection === 'horizontal') {
      this.mouseXY = event.clientX;
    } else {
      this.mouseXY = event.clientY;
    }

    // 使用requestAnimationFrame优化性能
    if (!this.isAnimating) {
      this.isAnimating = true;
      this.animationFrameId = requestAnimationFrame(() => {
        this.updateIconScales();
        this.isAnimating = false;
      });
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.mouseXY = Infinity;
    this.resetIconScales();
  }

  private updateIconScales(): void {
    const icons = this.dockContainer.nativeElement.querySelectorAll('.dock-icon');

    icons.forEach((icon: HTMLElement, index: number) => {
      const iconRect = icon.getBoundingClientRect();
      let iconCenter = 0;
      if (this.ncDirection == 'horizontal') {
        iconCenter = iconRect.left + iconRect.width / 2;
      } else {
        iconCenter = iconRect.top + iconRect.height / 2;
      }
      const distance = Math.abs(this.mouseXY - iconCenter);

      let scale = this.ncSize;
      if (distance < this.ncDistance) {
        const magnificationDelta = this.ncMultiple * this.ncSize - this.ncSize;
        // 使用平滑的二次函数曲线使效果更自然
        const distanceRatio = 1 - Math.pow(distance / this.ncDistance, 2);
        scale = this.ncSize + (magnificationDelta * distanceRatio);
      }

      // 不再使用Angular动画API，改为直接设置样式值让CSS过渡处理
      this.iconScales[index] = scale;
    });
  }

  onIconClick(index: number): void {
    this.ncClick.emit(index);
  }

  /**
   * 检查项目是否为SVG内容
   */
  isSvgContent(item: string): boolean {
    return !!item && (typeof item === 'string') && (item.trim().startsWith('<svg') || item.trim().startsWith('<?xml'));
  }

  /**
   * 返回安全处理后的SVG内容
   */
  getSanitizedSvg(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
